import { Request } from "@cttq/cttq-request";

const http = new Request({
  baseURL: import.meta.env.VITE_ORG_URL,
  responseInterceptors: (res: any) => res.data
});

export function getAllOrganizationVersion(data: any) {
  return http.post<any>({
    url: '/org/version/getAllOrganizationVersion',
    data
  })
}


//  根据组织架构版本查询组织架构树
export function getVersionAllDepts(params: any) {
  return http.get({
    url: '/org/dept/getAllDept',
    params
  })
}
